import { gql } from '@apollo/client';

export const CREATE_PRODUCT_NOT_FOUND_MAIL = gql`
    mutation CreateProductNotFoundMail($searchMailInput: SearchMailInputType!) {
        createProductNotFoundMail(searchMailInput: $searchMailInput)
    }
`;
